import React, { useState, useEffect } from "react";
import Layout, { Container } from "../components/layout";
import { apiurl } from "../config/config";
import { useUser } from "../config/userProvider";
import { useParams } from "react-router-dom";
import { getCookie } from "../config/webStorage";
import { Activity, Clock, Headphones, Users } from "lucide-react";

const leaveTypes = ["Casual Leave", "Sick Leave", "Earned Leave"];

export default function Attendance() {
  const  { userData } = useUser();
  const [user, setUser] = useState(userData);
  const [attendanceData, setAttendanceData] = useState({});
  const [appliedLeaves, setAppliedLeaves] = useState([]);
  const [form, setForm] = useState({
    type: "",
    from: "",
    to: "",
    message: "",
  });

  let token = getCookie("swtoken");

    const [open, setOpen] = useState(false);
  let {employeeId}= useParams();
  console.log("employeeId", employeeId);


  console.log("userData 20", userData);
  // useEffect(() => {
  //   // Simulate API call to fetch attendance
  //   const dataMap = {};
  //   dummyMongoAttendance.forEach((entry) => {
  //     dataMap[entry.date] = entry.status;
  //   });
  //   setAttendanceData(dataMap);
  // }, []);

  // useEffect(() => {
  //   fetch(
  //     "http://localhost:5050/api/attendance/monthly?employeeId=3890&month=5&year=2025"
  //   )
  //     .then((res) => res.json())
  //     .then((data) => {
  //       const formatted = {};
  //       data.forEach((entry) => {
  //         formatted[entry.date] = entry.status;
  //       });
  //       setAttendanceData(formatted);
  //     })
  //     .catch((err) => console.error("Error fetching attendance:", err));
  // }, []);


  

  const handleSubmit = (e) => {
    e.preventDefault();
    setAppliedLeaves([...appliedLeaves, { ...form, status: "Pending" }]);
    setForm({ type: "", from: "", to: "", message: "" });

    // TODO: Send to backend API (POST)
  };

  // const [currentDate, setCurrentDate] = useState(new Date(2025, 4)); // May 2025
  const [currentDate, setCurrentDate] = useState(() => {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), 1);
  });

  const handlePrevMonth = () => {
    setCurrentDate(
      new Date(currentDate.getFullYear(), currentDate.getMonth() - 1)
    );
  };

  const handleNextMonth = () => {
    setCurrentDate(
      new Date(currentDate.getFullYear(), currentDate.getMonth() + 1)
    );
  };

  // 4B49AC
  const getStatusColor = (status) => {
    if (!status) return "bg-gray-200 text-gray-700";

    switch (status.toLowerCase()) {
      case "present":
      case "p":
        return "bg-[#4CAF50] text-white"; // Green
      case "absent":
      case "a":
        return "bg-[#F44336] text-white"; // Red
      case "leave":
      case "cl":
        return "bg-[#2196F3] text-white"; // Blue (Casual Leave)
      case "pl":
      case "paidleave":
      case "pld":
        return "bg-[#3F51B5] text-white"; // Indigo (Paid Leave)
      case "ml":
        return "bg-[#FF9800] text-white"; // Orange (Medical Leave)
      case "maternity":
      case "m":
        return "bg-[#F8BBD0] text-black"; // Light Pink
      case "halfday":
      case "hd":
        return "bg-[#FFC107] text-black"; // Yellow (Half Day)
      case "holiday":
      case "h":
        return "bg-blue-500 text-white"; // Blue (Holiday)
      case "weekoff":
      case "wo":
        return "bg-[#9E9E9E] text-black"; // Grey (Week Off)
      case "misspunch":
        return "bg-[#FFB74D] text-black"; // Light Orange
      case "unpaid":
      case "ul":
      case "lop":
        return "bg-[#FF5722] text-white"; // Deep Orange (Loss of Pay)
      case "study":
      case "sl":
        return "bg-[#00BCD4] text-white"; // Cyan
      case "bereavement":
      case "bl":
        return "bg-[#6D4C41] text-white"; // Brown
      case "workfromhome":
      case "wfh":
        return "bg-[#009688] text-white"; // Teal
      case "onduty":
      case "od":
        return "bg-[#673AB7] text-white"; // Purple
      case "training":
      case "trn":
        return "bg-[#90CAF9] text-black"; // Light Blue
      case "earlyout":
      case "eod":
        return "bg-[#FFCDD2] text-black"; // Light Red
      case "upl":
        return "bg-[#C4D8E2] text-black"; // Light Indigo
      default:
        return "bg-gray-200 text-gray-700"; // Fallback
    }
  };
  useEffect(() => {
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth() + 1; // getMonth is 0-indexed
  
    fetch(
      `${apiurl}/api/attendance/monthly?employeeId=${employeeId}&month=${month}&year=${year}`
    )
      .then((res) => res.json())
      .then((data) => {
        const formatted = {};
        console.log("data", data);
        data.forEach((entry) => {
          formatted[entry.date] = {
            status: entry.status,
            checkIn: entry.checkin,
            checkOut: entry.checkout,
            officeDuration: entry.officeDuration,
            talktime: entry.talktime,
            workDuration: entry.workDuration
          };
        });
        setAttendanceData(formatted);
      })
      .catch((err) => console.error("Error fetching attendance:", err));
  }, [currentDate]);

  // const renderCalendar = () => {
  //   const year = 2025;
  //   const month = 4; // May (0-indexed)
  //   const firstDay = new Date(year, month, 1).getDay();
  //   const daysInMonth = new Date(year, month + 1, 0).getDate();
  //   const prevMonthDays = new Date(year, month, 0).getDate();
  //   const weekdayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  //   const weeks = [];
  //   let dayCounter = 1;
  //   let nextMonthDay = 1;

  //   for (let week = 0; week < 6; week++) {
  //     const days = [];

  //     for (let i = 0; i < 7; i++) {
  //       const dateIndex = week * 7 + i;
  //       let dayNum;
  //       let isCurrentMonth = true;
  //       let fullDate;

  //       if (dateIndex < firstDay) {
  //         dayNum = prevMonthDays - firstDay + 1 + i;
  //         isCurrentMonth = false;
  //         fullDate = "";
  //       } else if (dayCounter <= daysInMonth) {
  //         dayNum = dayCounter;
  //         fullDate = `${year}-05-${dayCounter.toString().padStart(2, "0")}`;
  //         dayCounter++;
  //       } else {
  //         dayNum = nextMonthDay++;
  //         isCurrentMonth = false;
  //         fullDate = "";
  //       }

  //       const status = isCurrentMonth ? attendanceData[fullDate] : null;

  //       days.push(
  //         <div
  //           key={week + "-" + i}
  //           className={`rounded-lg h-10 w-9 md:w-auto md:h-20 p-2 text-sm flex flex-col justify-center items-center md:items-start md:justify-between ${
  //             isCurrentMonth ? getStatusColor(status) : "bg-gray-100 text-gray-400"
  //           } ${isCurrentMonth ? "text-white" : ""}`}
  //         >
  //           <span className="font-bold">{dayNum}</span>
  //           <span className="text-xs hidden md:block">{isCurrentMonth ? status || "N/A" : ""}</span>
  //         </div>
  //       );
  //     }

  //     weeks.push(
  //       <div key={week} className="grid grid-cols-7 gap-2">
  //         {days}
  //       </div>
  //     );
  //   }

  //   return (
  //     <div className="space-y-2">
  //       <div className="grid grid-cols-7 gap-2 text-xs md:text-sm font-medium text-gray-600">
  //         {weekdayNames.map((day) => (
  //           <div key={day} className="text-center md:text-left">
  //             {day}
  //           </div>
  //         ))}
  //       </div>
  //       {weeks}
  //     </div>
  //   );
  // };
  
  
  // const renderCalendar = () => {
  //   const year = currentDate.getFullYear();
  //   const month = currentDate.getMonth(); // 0-indexed
  //   const today = new Date();
  //   const firstDay = new Date(year, month, 1).getDay();
  //   const daysInMonth = new Date(year, month + 1, 0).getDate();
  //   const prevMonthDays = new Date(year, month, 0).getDate();
  //   const weeks = [];
  //   let dayCounter = 1;
  //   let nextMonthDay = 1;
  
  //   for (let week = 0; week < 6; week++) {
  //     const days = [];
  
  //     for (let i = 0; i < 7; i++) {
  //       const dateIndex = week * 7 + i;
  //       let dayNum;
  //       let isCurrentMonth = true;
  //       let fullDate;
  //       let status = null;
  //       let isFuture = false;
  
  //       if (dateIndex < firstDay) {
  //         dayNum = prevMonthDays - firstDay + 1 + i;
  //         isCurrentMonth = false;
  //       } else if (dayCounter <= daysInMonth) {
  //         dayNum = dayCounter;
  //         fullDate = `${year}-${(month + 1)
  //           .toString()
  //           .padStart(2, "0")}-${dayCounter.toString().padStart(2, "0")}`;
  
  //         const thisDate = new Date(year, month, dayNum);
  //         isFuture = thisDate > today;
  
  //         status = attendanceData[fullDate];
  
  //         // override status if it's a future date and not leave
  //         if (isFuture && status !== "leave") {
  //           status = "future";
  //         }
  
  //         dayCounter++;
  //       } else {
  //         dayNum = nextMonthDay++;
  //         isCurrentMonth = false;
  //       }
  
  //       const bgColor =
  //         isCurrentMonth && status !== "future"
  //           ? getStatusColor(status)
  //           : isCurrentMonth && status === "future"
  //           ? "bg-gray-200"
  //           : "bg-gray-100 text-gray-400";
  
  //       days.push(
  //         <div
  //           key={`${week}-${i}`}
  //           className={`rounded-lg h-10 w-9 md:w-auto md:h-20 p-2 m-1 text-sm flex flex-col justify-center items-center md:items-start md:justify-between ${bgColor}`}
  //         >
  //           <span className="font-bold">{dayNum}</span>
  //           {isCurrentMonth && status && status !== "future" && (
  //             <span className="text-xs hidden md:block">{status}</span>
  //           )}
  //         </div>
  //       );
  //     }
  
  //     weeks.push(
  //       <div key={`week-${week}`} className="grid grid-cols-7 gap-2">
  //         {days}
  //       </div>
  //     );
  //   }
  
  //   return <div>{weeks}</div>;
  // };


  const formatTime = (value) => {
    console.log("value", value);
    if (!value) return "Missed";

    if (value.includes("T")) {
      const date = new Date(value);
      return date.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      });
    }

    if (/^\d{2}:\d{2}$/.test(value)) {
      const [hour, minute] = value.split(":");
      const date = new Date();
      date.setHours(parseInt(hour), parseInt(minute));
      return date.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      });
    }

    return value;
  };

  const formatDuration = (hours) => {
    if (!hours || hours <= 0) return "0h 0m";
    const h = Math.floor(hours);
    const m = Math.round((hours - h) * 60);
    return `${h}h ${m}m`;
  };


  const formatToHHMMSS = (value) => {
  if (!value) return "00:00:00";

  // If value is decimal (officeDuration)
  if (!isNaN(value) && value.includes?.(".") || Number(value) === value) {
    const hours = Math.floor(Number(value));
    const minutes = Math.floor((Number(value) - hours) * 60);
    const seconds = Math.round(((Number(value) - hours) * 60 - minutes) * 60);
    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  }

  // If value is "HH:MM"
  if (/^\d{1,2}:\d{2}$/.test(value)) {
    return `${value}:00`;
  }

  return value; // fallback
};


const renderCalendar = () => {
  const year = currentDate.getFullYear();
  const month = currentDate.getMonth();
  const today = new Date();
  const firstDay = new Date(year, month, 1).getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const prevMonthDays = new Date(year, month, 0).getDate();

  const weeks = [];
  let dayCounter = 1;
  let nextMonthDay = 1;

  for (let week = 0; week < 6; week++) {
    const days = [];

    for (let i = 0; i < 7; i++) {
      const dateIndex = week * 7 + i;
      let dayNum;
      let isCurrentMonth = true;
      let fullDate;
      let isFuture = false;
      let data = null;

      if (dateIndex < firstDay) {
        dayNum = prevMonthDays - firstDay + 1 + i;
        isCurrentMonth = false;
      } else if (dayCounter <= daysInMonth) {
        dayNum = dayCounter;
        fullDate = `${year}-${(month + 1).toString().padStart(2, "0")}-${dayCounter
          .toString()
          .padStart(2, "0")}`;

        const thisDate = new Date(year, month, dayNum);
        isFuture = thisDate > today;
        data = attendanceData[fullDate];

        if (isFuture && (!data || data?.status !== "leave")) {
          data = { status: "future" };
        }

        dayCounter++;
      } else {
        dayNum = nextMonthDay++;
        isCurrentMonth = false;
      }

      const bgColor =
        isCurrentMonth && data?.status !== "future"
          ? getStatusColor(data?.status)
          : isCurrentMonth && data?.status === "future"
          ? "bg-gray-200 text-gray-500"
          : "bg-gray-100 text-gray-400";

      days.push(
        <div
          key={`${week}-${i}`}
          className={`flex flex-col justify-between items-center p-3 rounded-xl shadow-sm border ${
            isCurrentMonth ? "cursor-pointer hover:shadow-lg transition" : ""
          } ${bgColor}`}
        >
          {/* Day number */}

                      <div className="flex justify-between items-center w-full">
          <span
            className={`font-semibold text-sm md:text-base ${
              isCurrentMonth ? "text-gray-800" : "text-gray-400"
            }`}
          >
            {dayNum}
          </span>

          {/* Status Badge */}
          {isCurrentMonth && data?.status && data?.status !== "future" && (
            <span
              className={`mt-1 px-2 py-0.5 rounded-full text-[10px] font-medium ${
                data.status === "present"
                  ? "bg-green-100 text-green-800"
                  : data.status === "absent"
                  ? "bg-red-100 text-red-800"
                  : data.status === "leave"
                  ? "bg-blue-100 text-blue-800"
                  : data.status === "halfday"
                  ? "bg-yellow-100 text-yellow-800"
                  : "bg-gray-100 text-gray-800"
              }`}
            >
              {data.status}
            </span>
          )}
</div>
          {/* Details (hidden on small screens) */}
          {isCurrentMonth && data?.status && data?.status !== "future" && (
            <div className="hidden md:flex flex-col mt-2 text-[11px] space-y-1 w-full">
              {/* <div>
                <span className="font-medium">CheckIn:</span>{" "}
                {formatTime(data.checkIn)}
              </div>
              <div>
                <span className="font-medium">CheckOut:</span>{" "}
                {formatTime(data.checkOut)}
              </div>
              <div>
                <span className="font-medium">Office Duration:</span>{" "}
                {data.officeDuration}
              </div>
              <div>
                <span className="font-medium">Talktime:</span> {data.talktime}
              </div>
              <div>
                <span className="font-medium">Work Duration:</span>{" "}
                {data.workDuration}
              </div> */}


                              <div className="flex items-center gap-1">
  <Clock size={14} /> <span className="text-[10px]">CheckIn: {formatToHHMMSS(data.checkIn)}</span>
</div>
<div className="flex items-center gap-1">
  <Clock size={14} /> <span className="text-[10px]">CheckOut: {formatToHHMMSS(data.checkOut)}</span>
</div>
<div className="flex items-center gap-1">
  <Activity size={14} /> <span className="text-[10px]">Office: {formatToHHMMSS(data.officeDuration)}</span>
</div>
<div className="flex items-center gap-1">
  <Users size={14} /> <span className="text-[10px]">Work: {formatToHHMMSS(data.workDuration)}</span>
</div>
<div className="flex items-center gap-1">
  <Headphones size={14} /> <span className="text-[10px]">Talktime: {formatToHHMMSS(data.talktime)}</span>
</div>

              
            </div>
          )}
        </div>
      );
    }

    weeks.push(
      <div key={week} className="grid grid-cols-7 gap-2">
        {days}
      </div>
    );
  }

  const weekdayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  return (
    <div className="space-y-2 mt-4">
      {/* Weekday header */}
      <div className="grid grid-cols-7 gap-2 text-xs md:text-sm font-semibold text-gray-600">
        {weekdayNames.map((day) => (
          <div key={day} className="text-center md:text-left">
            {day}
          </div>
        ))}
      </div>

      {/* Calendar weeks */}
      {weeks}
    </div>
  );
};

  
  return (
    <Layout>
      <Container overflow={"overflow-scroll"}>
        <div className="p-4 bg-[#f5f7fb] min-h-screen space-y-6 mb-16 md:mb-0">
        <div className="flex justify-between items-center">
          <h1 className="text-2xl font-semibold text-gray-800 mb-4">
            My Attendance
          </h1>


      <button
        onClick={() => setOpen(true)}
        className="px-6 py-3 bg-blue-600 text-white rounded-md shadow hover:bg-blue-700"
      >
        Manage Attendance
      </button>
        </div>

      <MarkAttendanceModal isOpen={open} employeeId={employeeId} onClose={() => setOpen(false)} token={token}/>

          <div className="flex justify-between items-center mb-4">
            <button
              onClick={handlePrevMonth}
              className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
            >
              ← Prev
            </button>
            <h2 className="text-xl font-semibold">
              Attendance Calendar –{" "}
              {currentDate.toLocaleString("default", { month: "long" })}{" "}
              {currentDate.getFullYear()}
            </h2>
            <button
              onClick={handleNextMonth}
              className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
            >
              Next →
            </button>
          </div>

          {/* Calendar */}
          <div className="bg-white rounded-2xl shadow p-6">
            <h2 className="text-xl font-semibold mb-4">
              Attendance Calendar -               {currentDate.toLocaleString("default", { month: "long" })}{" "}
              {currentDate.getFullYear()}
            </h2>
            {renderCalendar()}
            <div className="mt-4 flex flex-wrap gap-4 text-[11px] md:text-sm">
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 rounded-full bg-[#4CAF50]" /> Present
              </div>
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 rounded-full bg-[#F44336]" /> Absent
              </div>
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 rounded-full bg-[#2196F3]" /> Casual
                Leave (CL)
              </div>
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 rounded-full bg-[#3F51B5]" /> Paid Leave
                (PL)
              </div>
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 rounded-full bg-[#FF9800]" /> Medical
                Leave (ML)
              </div>
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 rounded-full bg-[#FFC107]" /> Half Day
              </div>
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 rounded-full bg-[#FFEB3B]" /> Holiday
              </div>
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 rounded-full bg-[#9E9E9E]" /> Week Off
              </div>
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 rounded-full bg-[#FFB74D]" /> Miss Punch
              </div>
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 rounded-full bg-[#FF5722]" /> Unpaid /
                LOP
              </div>
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 rounded-full bg-[#00BCD4]" /> Study
                Leave
              </div>
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 rounded-full bg-[#6D4C41]" />{" "}
                Bereavement Leave
              </div>
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 rounded-full bg-[#F8BBD0]" /> Maternity
                Leave
              </div>
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 rounded-full bg-[#009688]" /> Work From
                Home (WFH)
              </div>
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 rounded-full bg-[#673AB7]" /> On Duty
                (OD)
              </div>
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 rounded-full bg-[#90CAF9]" /> Training
                (TRN)
              </div>
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 rounded-full bg-[#FFCDD2]" /> Early Out
                (EOD)
              </div>
            </div>
          </div>

          {/* Applied Leaves */}
          <div className="bg-white rounded-2xl shadow p-6">
            <h2 className="text-xl font-semibold mb-4">Applied Leaves</h2>
            {appliedLeaves.length === 0 ? (
              <p className="text-gray-500">No leaves applied yet.</p>
            ) : (
              <ul className="space-y-2">
                {appliedLeaves.map((leave, idx) => (
                  <li
                    key={idx}
                    className="border p-3 rounded-md flex justify-between"
                  >
                    <div>
                      <p className="font-medium">{leave.type}</p>
                      <p className="text-sm text-gray-600">
                        {leave.from} to {leave.to}
                      </p>
                      <p className="text-sm text-gray-500">{leave.message}</p>
                    </div>
                    <span className="text-sm text-orange-500">
                      {leave.status}
                    </span>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </Container>
    </Layout>
  );
}





const MarkAttendanceModal = ({ isOpen, employeeId, onClose ,token}) => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [status, setStatus] = useState("present");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const today = new Date().toISOString().split("T")[0]; // YYYY-MM-DD

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      const response = await fetch(`${apiurl}/api/attendance/mark`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": token,
        },
        body: JSON.stringify({ employeeId, startDate, endDate, status }),
      });

      const result = await response.json();
      if (result.success) {
        setMessage("✅ Attendance marked successfully! Refreshing...");
        setStartDate("");
        setEndDate("");
        setStatus("present");

        // Auto refresh page after 1.5s
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      } else {
        setMessage("❌ " + result.message);
      }
    } catch (error) {
      setMessage("❌ Error connecting to server");
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/40 z-50">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-lg p-6 animate-fade-in">
        <h2 className="text-xl font-bold text-gray-800 mb-4">
          Mark Attendance : {employeeId}
        </h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Dates */}
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium mb-1">Start Date</label>
              <input
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                max={today} // 🚫 Prevent future date
                className="w-full border rounded-lg px-3 py-2"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">End Date</label>
              <input
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                max={today} // 🚫 Prevent future date
                className="w-full border rounded-lg px-3 py-2"
                required
              />
            </div>
          </div>

          {/* Status */}
          <div>
            <label className="block text-sm font-medium mb-1">Status</label>
            <select
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              className="w-full border rounded-lg px-3 py-2"
            >
              <option value="present">Present</option>
              <option value="absent">Absent</option>
              <option value="halfday">Half Day</option>
              <option value="leave">Leave</option>
              <option value="weekoff">Week Off</option>
              <option value="holiday">Holiday</option>
            </select>
          </div>

          {/* Message */}
          {message && (
            <p className="text-sm text-gray-700 flex items-center gap-2">
              {loading && (
                <span className="animate-spin border-2 border-green-600 border-t-transparent rounded-full w-4 h-4"></span>
              )}
              {message}
            </p>
          )}

          {/* Buttons */}
          <div className="flex justify-end gap-2 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 rounded-lg border border-gray-300 text-gray-700"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading}
              className="px-4 py-2 rounded-lg bg-green-600 text-white hover:bg-green-700"
            >
              {loading ? "Saving..." : "Save"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
